import { render } from "./UsbDataForm.vue?vue&type=template&id=01b67a49&scoped=true"
import script from "./UsbDataForm.vue?vue&type=script&lang=js"
export * from "./UsbDataForm.vue?vue&type=script&lang=js"

import "./UsbDataForm.vue?vue&type=style&index=0&id=01b67a49&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\90\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b67a49"]])

export default __exports__